import {
  BadgeCheck,
  BadgePercent,
  BarChart3,
  BookImageIcon,
  Boxes,
  Briefcase,
  CalendarDays,
  CircleHelp,
  FileQuestion,
  FolderTree,
  Gamepad2,
  Gift,
  ImagePlus,
  LayoutDashboard,
  ListOrdered,
  LucideWorkflow,
  Mail,
  Newspaper,
  Package,
  Package2,
  Palette,
  PanelBottom,
  PanelsTopLeft,
  PawPrint,
  PersonStanding,
  PlusCircle,
  PlusSquareIcon,
  Scissors,
  Settings,
  ShieldCheck,
  ShoppingBag,
  ShoppingBasket,
  SubscriptIcon,
  TicketPercent,
  Wallet,
  Workflow,
  WorkflowIcon,
} from "lucide-react";
import { JSX } from "react";

export interface NavItem {
  id: number;
  title?: string;
  icon?: JSX.Element;
  role: string;
  path?: string;
  type?: string;
  isSubItem?: boolean;
  children?: NavItem[];
}
export const allNav = [
  {
    id: 1,
    title: "Dashboard",
    icon: <LayoutDashboard />,
    role: "admin",
    path: "/admin/admindashboard",
  },
  {
    id: 33,
    title: "Analytics",
    icon: <BarChart3 />,
    role: "admin",
    path: "/admin/analytics",
  },
  {
    id: 2,
    title: "Order",
    icon: <ListOrdered />,
    role: "admin",
    path: "/admin/AdminOrdersDashboard",
  },
  {
    id: 2,
    title: "Subscription Orders",
    icon: <SubscriptIcon />,
    role: "admin",
    path: "/admin/AdminSubscriptionOrders",
  },
  {
    id: 3,
    title: "Booking Service",
    icon: <LayoutDashboard />,
    role: "admin",
    path: "/admin/AdminBookingService",
  },
  {
    id: 4,
    title: "Products",
    icon: <ShoppingBag />,
    role: "admin",
    type: "group",
    children: [
      {
        id: 5,
        title: "Product Management",
        icon: <Boxes />,
        role: "admin",
        path: "/admin/product/productmanagement",
        isSubItem: true,
      },
      {
        id: 6,
        title: "Brands Section",
        icon: <BadgeCheck />,
        role: "admin",
        path: "/admin/product/addbrand",
        isSubItem: true,
      },
      {
        id: 3,
        title: "Inventory Upload",
        icon: <Package />,
        role: "admin",
        path: "/admin/product/inventoryupload",
        isSubItem: true,
      },
      {
        id: 7,
        title: "Add New Product",
        icon: <PlusCircle />,
        role: "admin",
        path: "/admin/product/addproduct",
        isSubItem: true,
      },
    ],
  },
  {
    id: 30,
    title: "Category Management",
    icon: <FolderTree />,
    role: "admin",
    path: "/admin/categorymanagement",
  },

  {
    id: 8,
    title: "Offer Management",
    icon: <BadgePercent />,
    role: "admin",
    type: "group",
    children: [
      {
        id: 9,
        title: "Create Ad Banners",
        icon: <ImagePlus />,
        role: "admin",
        path: "/admin/offer/adBanner",
        isSubItem: true,
      },
      {
        id: 10,
        title: "Bundles",
        icon: <Gift />,
        role: "admin",
        path: "/admin/offer/bundlescreen",
        isSubItem: true,
      },
      // {
      //   id: 11,
      //   title: "Create Free Product",
      //   icon: <TicketPercent />,
      //   role: "admin",
      //   path: "/admin/offer/claimProduct",
      //   isSubItem: true,
      // },
      //   {
      //     id: 12,
      //     title: "Other Offers",
      //     icon: <BadgePercent />,
      //     role: "admin",
      //     path: "/admin/offer/otheroffers",
      //     isSubItem: true,
      //   },
      {
        id: 13,
        title: "Create Coupon",
        icon: <ImagePlus />,
        role: "admin",
        path: "/admin/offer/CouponManagement",
        isSubItem: true,
      },
    ],
  },
  {
    id: 14,
    title: "Pets",
    icon: <PawPrint />,
    role: "admin",
    path: "/admin/pets",
  },
  {
    id: 16,
    title: "Abandoned cart",
    icon: <ShoppingBasket />,
    role: "admin",
    path: "/admin/customerManagement/AbandonedCart",
  },

  {
    id: 17,
    title: "Customers",
    icon: <PersonStanding />,
    role: "admin",
    path: "/admin/customerManagement/CustomerAdminScreen",
  },

  {
    id: 13,
    title: "Services",
    icon: <Workflow />,
    role: "admin",
    type: "group",
    // path: "/admin/groomingBookings",
    children: [
      {
        id: 9,
        title: "Services",
        icon: <LucideWorkflow />,
        role: "admin",
        path: "/admin/services/ManageServices",
        isSubItem: true,
      },
      {
        id: 10,
        title: "Package",
        icon: <Package2 />,
        role: "admin",
        path: "/admin/services/ManagePackages",
        isSubItem: true,
      },
      {
        id: 11,
        title: "Weekdays",
        icon: <CalendarDays />,
        role: "admin",
        path: "/admin/services/ManageWeekdays",
        isSubItem: true,
      },
      {
        id: 11,
        title: "Employees",
        icon: <PanelsTopLeft />,
        role: "admin",
        path: "/admin/services/ManageEmployees",
        isSubItem: true,
      },
      {
        id: 12,
        title: "Service Offer",
        icon: <BookImageIcon />,
        role: "admin",
        path: "/admin/services/ManageOffers",
        isSubItem: true,
      },
      {
        id: 13,
        title: "Bookings",
        icon: <BookImageIcon />,
        role: "admin",
        path: "/admin/services/ManageBookings",
        isSubItem: true,
      },
      {
        id: 19,
        title: "Add-Ons",
        icon: <PlusSquareIcon />,
        role: "admin",
        path: "/admin/services/addOns",
        isSubItem: true,
      },
    ],
  },
  {
    id: 2,
    title: "UI Configuration",
    icon: <Palette />,
    role: "admin",
    path: "/admin/uiconfigure/sections",
  },

  {
    id: 15,
    title: "Footer Management",
    icon: <PanelBottom />,
    role: "admin",
    children: [
      {
        id: 16,
        title: "Careers",
        icon: <Briefcase />,
        role: "admin",
        path: "footer/Careers",
        isSubItem: true,
      },
      {
        id: 17,
        title: "Blog",
        icon: <Newspaper />,
        role: "admin",
        path: "footer/Blogs",
        isSubItem: true,
      },
      {
        id: 18,
        title: "FAQ",
        icon: <CircleHelp />,
        role: "admin",
        path: "footer/FAQ",
        isSubItem: true,
      },
      {
        id: 20,
        title: "Footer List",
        icon: <ShieldCheck />,
        role: "admin",
        path: "footer/footerList",
        isSubItem: true,
      },
    ],
  },
  {
    id: 31,
    title: "Customer Queries",
    icon: <FileQuestion />,
    role: "admin",
    path: "/admin/AdminQueriesScreen",
  },
  {
    id: 31,
    title: "Settings",
    icon: <Settings />,
    role: "admin",
    path: "/admin/adminsettings/adminsettings",
  },
  {
    id: 32,
    title: "Email Management",
    icon: <Mail />,
    role: "admin",
    path: "/admin/adminemailtemplates/emailtemplates",
  },
  //   {
  //     id: 25,
  //     title: "Gamification",
  //     icon: <Gamepad2 />,
  //     role: "admin",
  //     path: "/admin/gamification",
  //   },
  //   {
  //     id: 26,
  //     title: "Reports & Analytics",
  //     icon: <BarChart3 />,
  //     role: "admin",
  //     path: "/admin/reports",
  //   },
  //   {
  //     id: 27,
  //     title: "Wallet & Transactions",
  //     icon: <Wallet />,
  //     role: "admin",
  //     path: "/admin/transactions",
  //   },
];
